import { Component, OnInit, ViewChild, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { NotificationService } from 'src/app/Service/notification.service';
import { IScheduleDocInfo, ILatestStageDetails } from 'src/app/ViewModel/ScheduleDocumentModel';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { RespondWorkflowListModel } from 'src/app/ViewModel/RespondWorkflowModel';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { ScheduleWorkflowhistoryComponent } from '../../engineering-schedule/schedule-workflowhistory/schedule-workflowhistory.component';
import { DocumentService } from 'src/app/Service/document/document.service';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { FileUploadLibrary } from 'src/app/Service/file/file.service';
import { IDocumentRevHistoryModel } from 'src/app/ViewModel/DocumentModel';
import { Align } from '@progress/kendo-angular-popup';
import { BulkDTNComponent } from '../../transmittal/bulkdtn/bulkdtn.component';
import { DTNReleaseComponent } from '../../transmittal/dtnrelease/dtnrelease.component';
import { Module } from 'src/app/Service/element-details.data.service';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { DatePipe } from '@angular/common';
import { RespondWorflowActionComponent } from '../dialogs/respond-worflow-action/respond-worflow-action.component';
import { WorkflowTemplateDialogModel } from 'src/app/ViewModel/WorkflowTemplateDialogModel';
import { WorkflowActionModel } from 'src/app/ViewModel/WorkflowActionModel';
import { WorkflowTemplateStatusInputModel } from 'src/app/ViewModel/WorkflowTemplateStatusInputModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { upperCase } from 'lodash';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { ITransmittalDetailsModel } from 'src/app/ViewModel/TransmittalModel';
import { TransmittalMsgService } from 'src/app/Service/transmittal/transmittal.service';
import { Subscription } from 'rxjs';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { WFActionAssignedToComponent } from '../dialogs/wft-action-assignto/wft-action-asssignto.component';
import { WorkflowAssignedToModel } from 'src/app/ViewModel/WorkflowAssignedToModel';

@Component({
  selector: 'app-respond-worflow',
  templateUrl: './respond-worflow.component.html',
  styleUrls: ['./respond-worflow.component.css']
})
export class RespondWorflowComponent implements OnInit, OnDestroy {
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  public pageSize = 15;
  public pageSizes = [15, 30, 50, 100, {
    text: 'All',
    value: 'all'
  }];
  public hoverClass = '';
  public enableFilter = false;
  public IsShowSection = false;
  public totalCount: number = 0;
  public LastViewingRecords = 30;
  public enableFullscreen = false;
  public buttonType = 'MyDocuments';
  public documentStatus?: number = 1;
  public isShowDTNButton: boolean = true;
  public viewSchDoc: IScheduleDocInfo | undefined | null;
  public actionTakenCount: number = 0;
  public selectedTabIndex: number = 0;
  public selectedRootIndex: number = 0;
  public pendingActionCount: number = 0;
  public noOfDays = [30, 60, 90, 'All'];
  public LastViewingRecord: string = "30";
  public statusList: RoleFeatureModel[] = [];
  public selectedWFActionTabIndex: number = 0;
  public gridData: RespondWorkflowListModel[] = [];
  public viewWFAction!: null | RespondWorkflowListModel;
  public viewDciTabList: IScheduleDocInfo[] = [];
  public originalGridData: RespondWorkflowListModel[] = [];
  public pendingActionData: RespondWorkflowListModel[] = [];
  public actionTakenData: RespondWorkflowListModel[] = [];
  public totalData: RespondWorkflowListModel[] = [];
  public anchorElementPopup: any;
  public anchorAlignCenter: Align = { horizontal: 'center', vertical: 'bottom' };
  private popupAlignCenter: Align = { horizontal: 'center', vertical: 'top' };
  private anchorAlignRight: Align = { horizontal: 'right', vertical: 'bottom' };
  private popupAlignRight: Align = { horizontal: 'right', vertical: 'top' };
  private anchorAlignLeft: Align = { horizontal: 'left', vertical: 'bottom' };
  private popupAlignLeft: Align = { horizontal: 'left', vertical: 'top' };
  public popupMargin = { horizontal: -15, vertical: 10 };
  public revHistory: IDocumentRevHistoryModel | null = null;
  public showRevHistory: boolean = false;
  public obj: any;
  public viewWFActionTabList: RespondWorkflowListModel[] = [];
  public groupId!: number;
  public memberId!: number;
  public currentproject!: ProjectViewModel;
  public isAllworkflow: boolean = false;
  public isBulkApprove_enable: boolean = false;
  public canCreate: boolean = false;
  public isBulkDTN: boolean = false;
  public disciplineId: undefined | number;
  public structureId: undefined | number;
  public drawingdocID: undefined | number;
  public subWorkflow!: number;
  public from_Date: any;
  public to_Date: any;
  public schedule_Type: undefined | any[];
  public ismorefilter: boolean = false;
  public isfilter: boolean = false;
  public isBulkAction?: boolean = false;
  public ADSearchComponent: boolean = false;
  public ADSearchComponentdata: any;
  public bulkActionMessage: string | undefined;
  public respondWorkflowDetails: any;
  mm: number | never;
  @ViewChild('dciGrid') dciGrid: any;
  @ViewChild(RespondWorflowActionComponent) RespondWorflowActionComponent !: RespondWorflowActionComponent;
  @ViewChildren(RespondWorflowActionComponent) listofWorflowActionComponent: QueryList<RespondWorflowActionComponent> | undefined;
  public Unsubscribes: Subscription[] = [];

  constructor(public projectInfoService: ProjectInfoService, private encryptDecryptService: EncryptDecryptService, public commonService: CommonService, public workflowTemplateService: WorkflowTemplateService, public _notificationService: NotificationService, public dialog: MatDialog, private _docService: DocumentService, public datepipe: DatePipe, private _transmittalMsgService: TransmittalMsgService) {
    this.getStatusList();
    this.allData = this.allData.bind(this);
    this.mm = 10;
  }

  ngOnInit() {
    this.ADSearchComponentdata = "respond_workflow";
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.currentproject = this.commonService.getCurrentProjectDetails();
    this.enableMemberRoleFeatures();


    if (this.commonService.hasRequestedObject()) {
      setTimeout(() => {
        this.populateGrid(false);
      }, 2000);
    } else {
      this.populateGrid(false);
    }
    this.CheckUserAccess();
  }

  CheckUserAccess() {
    this.Unsubscribes.push(this.commonService.getProjectMemberRoles(this.currentproject.projectId, this.groupId, this.memberId).subscribe((result: any[]) => {
      this.canCreate = result.some(data => data.role_Short_Desc == 'ECD');
    }));
  }

  public toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  public toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  public receviewData(data: any) {
    this.disciplineId = data.disc_Id;
    this.structureId = data.struct_Id;
    this.subWorkflow = data.workflowId;
    this.drawingdocID = data.dwgID;
    this.from_Date = data.from_Date;
    this.to_Date = data.to_Date;
    this.schedule_Type = data.Doc_typeid
    if (!!this.disciplineId || !!this.structureId || !!this.subWorkflow || !!this.drawingdocID || !!this.from_Date || !!this.to_Date || this.schedule_Type) {
      this.isfilter = true;
      this.AdvanceFiler();
    } else {
      this.populateGrid(true);
    }
  }

  public lastviewingrecordsmethod(event: any) {
    this.LastViewingRecords = event;
    this.populateGrid(false);
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  viewTabClick(_event: MatTabChangeEvent) {
    this.viewSchDoc = null;
    if (this.selectedTabIndex != 0) {
      this.viewSchDoc = this.viewDciTabList[this.selectedTabIndex - 1];
    }
  }

  viewWFActionTabClick(_event: MatTabChangeEvent) {
    this.viewWFAction = null;
    if (this.selectedWFActionTabIndex != 0) {
      this.viewWFAction = this.viewWFActionTabList[this.selectedWFActionTabIndex - 1];
    }
  }

  viewDocumentClick(_data: any) {
    let data: IScheduleDocInfo = {
      doc_Id: _data.documentId,
      revision_No: _data.revisionNo,
      doc_No: _data.documentNumber,
      doc_Title: _data.documentTitle,
      doc_Set_Name: '',
      doc_Status: '',
      doc_Status_Id: null,
      print_Size: '',
      print_Size_Id: null,
      revision_Category: null,
      authorized_By: '',
      created_By: '',
      created_On: new Date(),
      reference: null,
      comments: null,
      noOfSheets: _data.noOfSheets,
      stages: null,
      workflow_Id: _data.workflowId,
      is_Latest: true,
      is_WF_Started: true,
      can_Restart_WF: false,
      dciScheduleStageDetails: null,
      dciScheduleElementDetails: null,
      isSelected: true,
      approved_Tag: true,
      approved_On: new Date(),
      isShowSupersedeIcon: false
    };
    let index = this.viewDciTabList.indexOf(data);
    if (index == -1) {
      this.viewDciTabList.push(data);
      this.selectedTabIndex = this.viewDciTabList.length;
    }
  }

  closeViewTab(tab: any) {
    this.viewDciTabList.forEach((value, index) => {
      if (value.doc_Id == tab.doc_Id)
        this.viewDciTabList.splice(index, 1);
    });
    if (this.viewDciTabList.length == 0) {
      this.selectedTabIndex = 0;
    }
  }

  public onClick_WorkflowHistory(dataItem: IScheduleDocInfo) {
    let dialogRef = this.dialog.open(ScheduleWorkflowhistoryComponent, {
      panelClass: 'mat-dialog-content',
      data: dataItem
    });
    dialogRef.afterClosed().subscribe((_data: any) => {
      // TODO document why this arrow function is empty
    });
  }

  closeWFActionViewTab(tab: any) {
    if (tab == null) {
      tab = this.viewWFActionTabList[this.selectedWFActionTabIndex - 1];
    }
    this.viewWFActionTabList.forEach((value, index) => {
      if (value.documentId == tab.documentId)
        this.viewWFActionTabList.splice(index, 1);
    });
    if (this.viewWFActionTabList.length > 0) {
      this.selectedWFActionTabIndex = 1;
      this.viewWFAction = this.viewWFActionTabList[this.selectedWFActionTabIndex - 1];
    }
    if (this.viewWFActionTabList.length == 0 || this.isBulkAction == true) {
      this.selectedWFActionTabIndex = 0;
      this.isBulkAction = false;
      this.viewWFActionTabList = [];
      this.populateGrid(false);
    }
  }

  public tabClick(event: MatTabChangeEvent) {
    if (event.tab.textLabel.toUpperCase().trim() == "PENDING ACTION")
      this.documentStatus = 1;
    else if (event.tab.textLabel.toUpperCase().trim() == "ACTION TAKEN")
      this.documentStatus = 2;
    else
      this.documentStatus = null;
    this.AdvanceFiler();
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  public onSelectionChange(event: any): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: any) => {
        element.dataItem.isSelected = true;
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: any) => {
        element.dataItem.isSelected = false;
      });
    }
  }

  public onValChange(value: string) {
    this.buttonType = value;
    this.LastViewingRecords = 30;
    this.selectedRootIndex = 0;
    this.documentStatus = 1;
    if (value == "MyDocuments")
      this.isShowDTNButton = true;
    else
      this.isShowDTNButton = false;
    this.populateGrid(false);
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  public getStatusList() {
    this.Unsubscribes.push(this.workflowTemplateService.getWorkflowTaskList(this.commonService.getLoggedInUserGroupId(), Module.Workflow, "Workflow", null, "Workflow Status", null, null, this.commonService.getProjectId()).subscribe(data => {
      this.statusList = data;
    }));
  }

  public async populateGrid(isFilterOnLocaldata: boolean) {
    if (isFilterOnLocaldata) {
      this.isfilter = false;
      this.ismorefilter = false;
      this.gridData = this.originalGridData;
      this.GridSettings();
    }
    if (!isFilterOnLocaldata) {
      this.Unsubscribes.push(await this.workflowTemplateService.getRespondWorkflowDetails(
        this.currentproject.projectId, this.groupId, this.memberId,
        this.LastViewingRecords.toString() != 'All' ? this.LastViewingRecords : null, this.documentStatus,
        this.buttonType == 'MyDocuments' ? false : true,
        this.buttonType == 'AllWorkflow' ? true : false
      ).subscribe((data: RespondWorkflowListModel[]) => {
        this.originalGridData = data;
        this.gridData = this.originalGridData;
        this.GridSettings();
        if (this.gridData.length > 0 && this.commonService.hasRequestedObject()) {
          /*Mail Redirection*/
          var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
          let inputDocId = requestedObject['inputDocId'];
          if (inputDocId) {
            this.commonService.checkAndDeleteRequestedObject();
            this.onClick_WorkflowAction(inputDocId);
          }
        }
      }));
    }
  }

  public GridSettings() {
    this.gridData.forEach(x => x.isSelected = false);
    this.OrganizeGridData();
    this.dciGrid.defaultSelection.selectedKeys = [];
  }

  public viewAttachmentClick(dataItem: any) {
    this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: {
        projectId: dataItem.projectId,
        docId: dataItem.documentId,
        revisionNo: dataItem.revisionNo,
        libraryName: [FileUploadLibrary.WorkflowDocument, FileUploadLibrary.SignedDocuments],
        createdBy: this.commonService.getLoggedInUserId(),
        isDeleteEnable: false,
        documentNo: dataItem.documentNumber
      },
    });
  }

  public openRevHistory(event: Event, dataItem: any) {
    this.showRevHistory = !this.showRevHistory;
    if (this.showRevHistory) {
      this.revHistory = {
        docId: dataItem.documentId,
        groupId: this.groupId,
        memberId: this.memberId,
        transType: "Project"
      };
    } else {
      this.revHistory = null;
    }
    this.anchorElementPopup = event.target;
  }

  public closeRevHistory() {
    this.showRevHistory = false;
    this.anchorElementPopup = undefined;
  }

  public onClick_WorkflowAction(documentId: number, _IsbulkAction?: boolean, _IsbulkApprove?: boolean, _IsbulkRevert?: boolean, assignedToId?: number) {
    this.ADSearchComponent = false;
    let dciToRespondWorkflow: RespondWorkflowListModel[] = [];
    if (documentId) {
      if (dciToRespondWorkflow.filter(x => x.documentId == documentId).length == 0)
        dciToRespondWorkflow.push(this.gridData.filter(x => (x.documentId == documentId && x.completedOn == null && x.actionPerformed == null && x.assignedToId == assignedToId))[0]);
    }
    if (!documentId) {
      this.gridData.filter(x => x.isSelected).forEach(y => {
        if (dciToRespondWorkflow.filter(x => x.documentId == y.documentId).length == 0)
          dciToRespondWorkflow.push(y);
      });
    }
    if (dciToRespondWorkflow.length == 0) {
      this._notificationService.showToast("No document is selected to take action", "Warning");
    }
    dciToRespondWorkflow.forEach(data => {
      let index = this.viewWFActionTabList.indexOf(data);
      if (index == -1)
        this.viewWFActionTabList.push(data);
    });
    if (_IsbulkApprove || _IsbulkRevert) {
      this.respondWorkflowDetails = {
        "projectId": 0,
        "groupId": 0,
        respondWorkflowDetails: [],
        createdBy: 0,
        stageDetails: []
      };
      let _disObj = this.viewWFActionTabList.filter(
        (thing, i, arr) => arr.findIndex(t => t.workflowId === thing.workflowId) === i
      );
      if (_disObj && _disObj.length > 1) {
        this._notificationService.showToast("Selected Document's in different workflow", "Warning");
      } else {
        this.Unsubscribes.push(this.workflowTemplateService.getWorkflowTemplate(_disObj[0].workflowId).subscribe((data: WorkflowTemplateDialogModel) => {

          this.onclick_action(data, _IsbulkApprove, _IsbulkRevert)
        }));
      }
    } else {
      if (this.viewWFActionTabList) {
        if (this.viewWFActionTabList.length > 10) {
          this._notificationService.showToast("Maximum ten document's only Allowed", "Warning");
          this.isBulkAction = false;
          this.viewWFActionTabList = [];
        } else if (this.viewWFActionTabList.length > 0) {

          this.isBulkAction = _IsbulkAction;
          this.selectedWFActionTabIndex = 1;
          this.viewWFAction = this.viewWFActionTabList[this.selectedWFActionTabIndex - 1];
        }
      }
    }
  }

  public onClick_DTNPreparation() {
    let dtnList: RespondWorkflowListModel[] = [];
    let selectedWf;
    let isShowdDtnWf: Map<number, Boolean | null | undefined> = new Map<number,
      Boolean | null | undefined>()
    this.gridData.filter(x => x.isSelected).forEach(y => {
      dtnList.push(y);
    });
    if (dtnList.length <= 0) {
      this._notificationService.showToast("No document is selected to take action", "Warning");
      return;
    }
    let wrongSelection = dtnList.filter(x => (x.integrationType != null || x.integrationType != '') && x.integrationType.toUpperCase().trim() != 'DTN PREPARATION');
    if (wrongSelection && wrongSelection.length >= 1) {
      this._notificationService.showToast("All selected Document's should be in DTN Preparation stage", "Warning");
      return;
    }
    let list = dtnList.map(x => {
      if (!isShowdDtnWf.has(x.workflowId)) {
        isShowdDtnWf.set(x.workflowId, x.is_Show_DTN_Attachment_Task_Id != null ? true : false);
      }
    })
    for (let key of isShowdDtnWf.keys()) {
      if (isShowdDtnWf.values().next().value != isShowdDtnWf.get(key)) {
        this._notificationService.showToast("The Workflows of the selected document is not compatible for dtn preparation", "Warning");
        return;
      }
    }
    let dialogRef = this.dialog.open(BulkDTNComponent, {
      panelClass: 'mat-dialog-primary',
      data: {
        inputType: 'dtnPreparation',
        selectedList: dtnList
      },
      autoFocus: false,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((_data: any) => {
      this.populateGrid(false);
    });
  }

  public async onClick_DTNRelease() {
    let dtnList: RespondWorkflowListModel[] = [];
    let selectedCommentSheetNo: any = null;
    let transmittalList: ITransmittalDetailsModel[] = [];
    let transmittalDocumentDetails: any;
    let documentList: any[] = [];
    let selectedMessageId = new Set<number>();
    this.gridData.filter(x => x.isSelected).forEach(y => {
      dtnList.push(y);
    });
    if (dtnList.length <= 0) {
      this._notificationService.showToast("No document is selected to take action", "Warning");
      return;
    }
    let selectedWf = dtnList[0].workflowId;
    let wrongSelection = dtnList.filter(x => (x.integrationType != null || x.integrationType != '') && x.integrationType.toUpperCase().trim() != "DTN RELEASE");
    if (wrongSelection && wrongSelection.length >= 1) {
      this._notificationService.showToast("All selected Document's should be in DTN Release stage", "Warning");
      return;
    }
    if (!!dtnList && dtnList.length >= 1) {
      await this._transmittalMsgService.GetTransmittalList({
        project_id: this.commonService.getProjectId()
      }).toPromise().then(x => {
        transmittalList = x;
        dtnList.forEach(x => {
          let data = transmittalList.filter(ele => ele.documentNo == x.documentNumber && ele.message_Number == ele.message_Id.toString());
          if (data && data.length > 0) {
            if (!selectedMessageId.has(data[0].message_Id))
              selectedMessageId.add(data[0].message_Id);
          }
        });
        if (selectedMessageId.size > 1) {
          this._notificationService.showToast("The Selected Documents Have More Than One Transmittal No", "Warning");
          return;
        } else {
          selectedCommentSheetNo = selectedMessageId.values().next().value
        }
      })
      if (selectedCommentSheetNo != null) {
        await this._transmittalMsgService.GetTransmittalDocumentDetails(selectedCommentSheetNo).toPromise().then(data => {
          transmittalDocumentDetails = data;
          data.transmittalDocumentDetails.forEach(y => {
            let doc = this.gridData.filter(x => x.documentId == y.doc_Id && ((x.integrationType != null || x.integrationType != '') && x.integrationType.toUpperCase().trim() == "DTN RELEASE"));

            if (doc.length > 0)
              documentList.push(doc);
            else {
              this.Unsubscribes.push(this.workflowTemplateService.getRespondWorkflowDetails(
                this.currentproject.projectId,
                this.groupId,
                null,
                null,
                null,
                false,
                false,
                y.doc_Id,
                y.revision_No
              ).subscribe((res: RespondWorkflowListModel[]) => {
                let op = res.filter(x => x.documentId == y.doc_Id && ((x.integrationType != null || x.integrationType != '') && x.integrationType.toUpperCase().trim() == "DTN RELEASE"));
                documentList.push(op);
              }));
            }
          })
        })
      }
    }
    if (selectedWf && (selectedCommentSheetNo != null) && dtnList.length > 0 && transmittalDocumentDetails.transmittalDocumentDetails.length > 0) {
      let dialogRef = this.dialog.open(DTNReleaseComponent, {
        panelClass: 'mat-dialog-primary',
        data: {
          projectId: this.commonService.getProjectId(),
          inputType: 'dtnRelease',
          workflowId: selectedWf,
          selectedList: dtnList,
          selectedCommentSheetNo: selectedCommentSheetNo,
          transmittalList: transmittalList,
          documentList: documentList,
          transmittalDocumentDetails: transmittalDocumentDetails
        },
        autoFocus: false,
        disableClose: true
      });
      dialogRef.afterClosed().subscribe((_data: any) => {
        this.populateGrid(false);
      });
    }
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.gridData
    };
    return result;
  }

  public BulkSubmit() {
    this.RespondWorflowActionComponent.BulkSubmit(this.listofWorflowActionComponent);
  }

  enableMemberRoleFeatures() {
    this.Unsubscribes.push(this.commonService.getProjectMemberFeatures(this.currentproject.projectId, this.memberId, this.groupId).subscribe((res: any[]) => {
      this.isAllworkflow = res.some(data => data.feature_Desc == 'Super Workflow');
      this.isBulkApprove_enable = res.some(data => data.feature_Desc == 'Bulk approve in SH and DDH stage');
    }));
  }

  AdvanceSearch() {
    this.ADSearchComponent = !this.ADSearchComponent
    if (!this.ADSearchComponent) {
      this.gridData = this.originalGridData;
      this.GridSettings();
    }
  }

  public onclick_action(currentWorkflowDetails: any, _IsbulkApprove?: boolean, _IsbulkRevert?: boolean) {
    let action: any;
    let getValue: any;
    let currentTask: any;
    let LatestStageDetails: ILatestStageDetails[] = [];
    let SendMailOnActionCompletionInputModel: any[] = [];
    for (var x of this.viewWFActionTabList) {
      getValue = x;
      if (getValue.taskName && (upperCase(getValue.taskName.trim()) == "SH APPROVAL IN PROGRESS" || upperCase(getValue.taskName.trim()) == "DDH APPROVAL IN PROGRESS")) {
        currentTask = currentWorkflowDetails.workflowStatus.filter((item: any) => item.sub_Workflow == getValue.subWorkflow && item.workflow_Status_Description.toUpperCase().trim() == getValue.taskName.toUpperCase().trim())[0];
        if (_IsbulkApprove)
          action = currentWorkflowDetails.workflowAction.filter((x: any) => (x.task_Id == getValue.currentTaskId) && (x.action_Description == "Approve"))[0];
        else
          action = currentWorkflowDetails.workflowAction.filter((x: any) => (x.task_Id == getValue.currentTaskId) && (x.action_Description == "Revert"))[0];
        let workflowActions: WorkflowActionModel[] = currentWorkflowDetails.workflowAction.filter((x: any) => x.task_Id == currentTask.task_Id);
        if (!!workflowActions && workflowActions.length > 0) {
          let v = currentWorkflowDetails.workflowAction.filter((x: any) => x.enable_Tag && x.task_Id == currentTask.task_Id);
          let SupersedeSubWorkflows = v.map((item: any) => item.next_Step_Sub_Workflow).filter((value: any, index: number, self: any) => self.indexOf(value) === index).join(',');
          let currentActionDetails = currentWorkflowDetails.workflowAction.filter((item: any) => item.task_Id == getValue.currentTaskId && item.action_Id == action.action_Id);
          let _respondWorkflowDetails: any = {
            "projectId": 0,
            "groupId": 0,
            respondWorkflowDetails: [],
            createdBy: 0,
            stageDetails: []
          };
          let obj: any = {};
          obj["documentId"] = getValue.documentId;
          obj["revisionNumber"] = getValue.revisionNo;
          //track 2 only required if that step is in super seed
          obj["nextRevisionNumber"] = null
          obj["workflowId"] = getValue.workflowId;
          obj["TaskId"] = getValue.currentTaskId;
          obj["assignType"] = getValue.assignedType;
          obj["memberId"] = this.memberId;
          getValue.assignedToId;
          obj["actionPerformed"] = action.action_Id;
          obj["completedBy"] = this.memberId;
          obj["statusId"] = currentActionDetails[0].status_Id;
          // is complted on manul field enabled in workflow template
          obj["completedOn"] = null;
          obj["commentSheetNo"] = null;
          obj["comments"] = getValue.comments;
          obj["delayReason"] = getValue.delayReason;
          obj["internalReason"] = getValue.internalReason;
          obj["externalReason"] = getValue.externalReason;
          // track 1
          obj["isFileAvailable"] = true;
          obj["taskSlNo"] = getValue.taskSerialNumber;
          //track 3
          //is Is Update Document Revision Status is true in workflow template
          obj["docStatus"] = null;

          this.respondWorkflowDetails.projectId = getValue.projectId;
          this.respondWorkflowDetails.groupId = getValue.groupId;
          this.respondWorkflowDetails.createdBy = this.memberId;
          this.respondWorkflowDetails.stageDetails = LatestStageDetails;
          this.respondWorkflowDetails.respondWorkflowDetails.push(obj);

          SendMailOnActionCompletionInputModel.push({
            projectId: this.currentproject.projectId,
            groupId: this.groupId,
            documentId: getValue.documentId,
            documentRevision: getValue.revisionNo,
            workflowId: getValue.workflowId,
            createdBy: this.memberId,
            Doc_Title: getValue.documentTitle,
            Doc_No: getValue.documentNumber,
            toSendSingleMail: false
          });
          if (this.viewWFActionTabList.length - 1 == this.viewWFActionTabList.indexOf(x))
            this.Unsubscribes.push(this.workflowTemplateService.BulkPostRespondWorkflowDetails(this.respondWorkflowDetails).subscribe(data => {
              if (data["successCode"] == 200) {
                this._notificationService.showToast(data["successMessage"], "Success");
                let isChangeUserPopupToShow = Boolean(JSON.parse(data["result"].toString().split(',')[0]));
                let _nextStepId = parseInt(JSON.parse(data["result"].toString().split(',')[1]));
                this.workflowTemplateService.BulkSendMailOnActionCompletion(SendMailOnActionCompletionInputModel).subscribe((_res: StandardOutputModel) => {
                  this.afterDailogClose("", data);
                  this.populateGrid(false);
                  this.viewWFActionTabList = [];
                })
              }
            }));
        }
      } else {
        this._notificationService.showPopup("Document's current workflow task  Must be  in 'SH Approval In Progress.' or 'DDH Approval In Progress'. Please Check Selected Document's    ", "Warning");
        this.respondWorkflowDetails = [];
        this.viewWFActionTabList = [];
        break;
      }
    }
  }

  public assignNextStep(_respondWorkflowDetails: any, _action: WorkflowActionModel, currentWorkflowDetails: any, wfInputDetails: any) {
    this.Unsubscribes.push(this.workflowTemplateService.postRespondWorkflowDetails(_respondWorkflowDetails).subscribe(data => {
      data["doc_no"] = wfInputDetails.documentNumber;
      if (data["successCode"] == 200) {
        let isChangeUserPopupToShow = Boolean(JSON.parse(data["result"].toString().split(',')[0]));
        let _nextStepId = parseInt(JSON.parse(data["result"].toString().split(',')[1]));
        let stepDetail: WorkflowTemplateStatusInputModel = currentWorkflowDetails.workflowStatus.filter((x: any) => x.step_Id == _nextStepId)[0];
      } else {
        this.bulkActionMessage += data["doc_no"] + " " + data["successMessage"]
      }
    }));
  }

  public SendMailOnActionCompletion(data: any, stepDetails: WorkflowTemplateStatusInputModel, successData: any, wfInputDetails: any) {
    let reqData: any = {
      projectId: this.currentproject.projectId,
      groupId: this.groupId,
      documentId: wfInputDetails.documentId,
      documentRevision: wfInputDetails.revisionNo,
      workflowId: stepDetails.workflow_Id,
      createdBy: this.memberId
    };
    this.Unsubscribes.push(this.workflowTemplateService.SendMailOnActionCompletion(reqData).subscribe((_res: StandardOutputModel) => {
      this.afterDailogClose(data, successData);
    }));
  }

  public afterDailogClose(x: any, data: any) {
    if (!!x && x == "-1") {
      this.bulkActionMessage += data["doc_no"] + " " + data["successMessage"]
    } else {
      if (!!x && x.successCode == 200) {
        this.bulkActionMessage += data["doc_no"] + " " + data["successMessage"]
      } else {
        this.bulkActionMessage += data["doc_no"] + " " + "Failed to update next step user";
      }
    }
  }

  public CopyDetails(Data: any) {
    let _copy_check_list_obj = JSON.stringify(Data.selectedChecklistCollection);
    let _obj: any = this.listofWorflowActionComponent
    let _check_list: any[] = [];
    if (_obj._results) {
      _obj._results.forEach((x: any) => {
        if (x.isChecklistRequired && x.wfInputDetails.documentDisciplineId == Data.wfInputDetails.documentDisciplineId && x.wfInputDetails.documentId != Data.wfInputDetails.documentId) {
          x.selectedChecklistCollection = JSON.parse(_copy_check_list_obj);
          _check_list.push({
            Doc_Id: x._wfDetails.documentId,
            Doc_Revision: x._wfDetails.revisionNo,
            Parent_Doc_Id: Data.wfInputDetails.documentId,
            Parent_Doc_Revision: Data.wfInputDetails.revisionNo,
            Task_Sl_No: x._wfDetails.taskSerialNumber
          });

          x.selectedChecklistCollection = x.selectedChecklistCollection.map(y => {
            y.documentNumber = x._wfDetails.documentNumber
            y.documentId = x._wfDetails.documentId
            y.documentRevisionNo = x._wfDetails.revisionNo
            y.documentTitle = x._wfDetails.documentTitle
            y.taskSerialNumber = x._wfDetails.taskSerialNumber

            return y;
          });
        };

      });
      if (_check_list && _check_list.length > 0)
        this.workflowTemplateService.PostWorkflowDocumentCopyCheckist(_check_list).subscribe(data => {
          if (data["successCode"] == 200) {
            _obj._results.forEach((x: any) => {
              if (x.isChecklistRequired && x.wfInputDetails.documentDisciplineId == Data.wfInputDetails.documentDisciplineId && x.wfInputDetails.documentId != Data.wfInputDetails.documentId) {
                x.is_checklistCopied = true;
              }
            });

            this._notificationService.showToast(data["successMessage"], "Success");
          }
        });
    }
  }

  public HelpUrlClick() {
    let x = JSON.parse(this.commonService.getSessionStorageItem("Menu"))
    let url = x.filter((y: any) => y.menuDesc == "Respond Workflow")[0].helpUrl
    if (url) {
      window.open(url);
    }
  }

  ngOnDestroy(): void {
    this.Unsubscribes.forEach(x => x.unsubscribe());
  }

  AdvanceFiler() {
    this.gridData = this.originalGridData;

    this.gridData = this.gridData.filter(data =>
      (!this.disciplineId || data.documentDisciplineId == this.disciplineId) &&
      (!this.structureId || data.documentStructureId == this.structureId) &&
      (!this.subWorkflow || data.subWorkflow == this.subWorkflow) &&
      (!this.drawingdocID || data.drawingdocID == this.drawingdocID) &&
      (!this.schedule_Type || this.schedule_Type.indexOf(data.schedule_Type) !== -1)
    )
    if (!!this.from_Date && !!this.to_Date) {
      let fromDate = new Date(this.datepipe.transform(this.from_Date, "dd-MMM-yyyy"));
      let toDate = new Date(this.datepipe.transform(this.to_Date, "dd-MMM-yyyy"));
      this.gridData = this.gridData.filter(x => {
        let s_date = new Date(this.datepipe.transform(x.assignedOn, "dd-MMM-yyyy"));
        return s_date >= fromDate && s_date <= toDate;
      });
    }
    let _griddata = JSON.parse(JSON.stringify(this.gridData));
    if (this.documentStatus == 1) {
      this.gridData = this.gridData.filter(x => x.actionPerformed == null);
    } else if (this.documentStatus == 2) {
      this.gridData = this.gridData.filter(x => x.actionPerformed != null);
    }
    this.pendingActionCount = _griddata.filter((x: any) => x.actionPerformed == null).length;
    this.actionTakenCount = _griddata.filter((x: any) => x.actionPerformed != null).length;
    this.totalCount = _griddata.length;
  }

  OrganizeGridData() {
    if (this.documentStatus == 1) {
      this.gridData = this.originalGridData.filter(x => x.actionPerformed == null);
    } else if (this.documentStatus == 2) {
      this.gridData = this.originalGridData.filter(x => x.actionPerformed != null);
    } else if (this.documentStatus == null) {
      this.gridData = this.originalGridData;
    }
    this.pendingActionCount = this.originalGridData.filter(x => x.actionPerformed == null).length;
    this.actionTakenCount = this.originalGridData.filter(x => x.actionPerformed != null).length;
    this.totalCount = this.originalGridData.length;
  }

  changeAssignedTo(workflowDetails: RespondWorkflowListModel) {
    let workflowTemplateDetails!: WorkflowTemplateDialogModel;
    this.workflowTemplateService.getWorkflowTemplate(workflowDetails.workflowId).subscribe((res: WorkflowTemplateDialogModel) => {
      workflowTemplateDetails = res;
      let stepDetail: WorkflowTemplateStatusInputModel = workflowTemplateDetails.workflowStatus.filter(x => x.step_Id == workflowDetails.currentTaskId)[0];
      let nextStepAssignedToRoles: WorkflowAssignedToModel[] = workflowTemplateDetails.workflowAssignedTo.filter(x => x.task_Id == stepDetail.task_Id && x.assign_Type == 1).filter(r => r.role_Id > 0);
      let nextStepAssignedToMembers: WorkflowAssignedToModel[] = workflowTemplateDetails.workflowAssignedTo.filter(x => x.task_Id == stepDetail.task_Id && x.assign_Type == 1).filter(r => r.role_Id == 0 && r.member_Id > 0);
      if (!!stepDetail && !!nextStepAssignedToRoles && nextStepAssignedToRoles.length > 0) {

        let dialogrRef = this.dialog.open(WFActionAssignedToComponent, {
          panelClass: 'mat-dialog-secondary',
          width: '800px',
          data: {
            title:'Current Step Member Re Assignment',
            docId: workflowDetails.documentId,
            docNo: workflowDetails.documentNumber,
            revisionNo: workflowDetails.revisionNo,
            docDiscipline: workflowDetails.documentDisciplineId,
            docDisciplineDEId: workflowDetails.documentDisciplineDEId,
            nextStep: stepDetail,
            assignedToRoles: nextStepAssignedToRoles,
            assignedToMembers: nextStepAssignedToMembers && nextStepAssignedToMembers.length > 0 ? nextStepAssignedToMembers : null,
            docTaskId: workflowDetails.taskSerialNumber,
            isReassign: true
          },
          autoFocus: false,
          disableClose: true
        });
        dialogrRef.afterClosed().subscribe((x: any) => {
          if (!!x) {
            if (x.successCode == 200) {
              this._notificationService.showToast("Re-Assigment Successful!!!", "Success");
              this.populateGrid(false);
            }
          } else {
            this._notificationService.showToast("Failed to update next step user", "Warning");
            this.populateGrid(false);
          }
        })
      } else if (!!stepDetail && !!nextStepAssignedToMembers && nextStepAssignedToMembers.length > 0) {
        let dialogrRef = this.dialog.open(WFActionAssignedToComponent, {
          panelClass: 'mat-dialog-secondary',
          width: '800px',
          data: {
            title:'Current Step Member Re Assignment',
            docId: workflowDetails.documentId,
            docNo: workflowDetails.documentNumber,
            revisionNo: workflowDetails.revisionNo,
            docDiscipline: workflowDetails.documentDisciplineId,
            docDisciplineDEId: workflowDetails.documentDisciplineDEId,
            nextStep: stepDetail,
            assignedToRoles: null,
            assignedToMembers: nextStepAssignedToMembers,
            docTaskId: workflowDetails.taskSerialNumber,
            isReassign: true
          },
          autoFocus: false,
          disableClose: true
        });
        dialogrRef.afterClosed().subscribe((x: any) => {
          if (!!x) {
            if (x.successCode == 200) {
              this._notificationService.showToast("Re-Assigment Successful!!!", "Success");
              this.populateGrid(false);
            }
          } else {
            this._notificationService.showToast("Failed to update next step user", "Warning");
            this.populateGrid(false);
          }
        })
      }
    })
  }
}